export const postBookingSurveyPageId = (isProdEnv: boolean) =>
  isProdEnv
    ? "prod-capital-one-travel-web-embed"
    : "test-capital-one-travel-web-embed";
